import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as authActions from '../actions/auth';
import * as customerActions from '../actions/customer';
import * as merchantActions from '../actions/merchant';
import * as searchActions from '../actions/search';

import AuthHeader from './AuthHeader';
import logo from '../assets/images/Localvore_Reverse.png';
import badge from '../assets/images/Localvore_icon_white_red.png';

class Header extends React.Component {
  render() {
    const { auth, customer, entities } = this.props;

    return(
      <nav className={classNames('navbar', 'fixed-top', 'navbar-light', 'bg-faded')} style={{zIndex: 201}}>
        <div className='navbar-container container d-flex justify-content-md-between align-items-center'>
          <Link className='navbar-brand' to='/'>
            <img src={logo}
                 alt='localvore logo'
                 className='logo hidden-xs-down'/>

            <img src={badge}
                 alt='localvore logo badge'
                 className='icon hidden-sm-up' />

          </Link>
          <span className='nav-text mr-auto hidden-md-down'>for Restaurants, Farmers & Producers</span>
          <ul
            className={classNames(
              "d-flex",
              "flex-row-reverse",
              "m-0",
              "header-navbar-list",
              {
                "ml-auto": !auth.get("user").get("isLoggedIn") || !(entities.get("vendors").size > 0)
              }
            )}
          >
            {!auth.get("user").get("isLoggedIn") &&
              <li className="ml-auto">
                <a onClick={() => this.props._auth.toggleAuthenticationModal()}>
                  Sign In / Sign Up
                </a>
              </li>}
            {!auth.get("user").get("isLoggedIn") &&
              <li>
                <a href="mailto:help@localvore.co" className="mr-3">Help</a>
              </li>}
            {auth.get("user").get("isLoggedIn") &&
              customer.get("loaded") &&
              <li className="header-authenticated">
                <AuthHeader {...this.props} />
              </li>}
          </ul>
        </div>
      </nav>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    customer: state.customer,
    entities: state.entities,
    routing: state.routing,
    vendor: state.entities
      .get('vendors')
      .get(state.customer
        .get('account')
        .get('activeVendorId'))
  }
}

function mapDispatchToProps(dispatch) {
  return {
    _auth: bindActionCreators(authActions, dispatch),
    _customer: bindActionCreators(customerActions, dispatch),
    _merchant: bindActionCreators(merchantActions, dispatch),
    _search: bindActionCreators(searchActions, dispatch)
  }
}

export const HeaderContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js